import React from 'react';
import { CardBody, Col } from 'reactstrap';

import { Text } from '~/components/Text';
import { TextCardSplitDash } from '~/components/TextCardSplitDash';
import { LoaderMini } from '~/components/Loaders';
import { priceFormatter } from '~/helpers/price';
import { color } from '~/assets/styles/colors';
import { Card, Tag, Symbol, Price } from './styles';

export function CardPrimeDash(props) {
	const {
		bgcolor,
		titulo,
		subtitulo,
		valorAtual,
		valorOntem,
		porcentagem,
		loading,
	} = props;

	return (
		<div className="d-flex h-100">
			<Col md="9" className="px-0">
				<Card bgcolor={bgcolor}>
					<CardBody>
						<div className="d-flex justify-content-between">
							<Text weight="bold" size="small">
								{titulo.texto}
							</Text>
							<Text weight="bold" size="small">
								{subtitulo.texto}
							</Text>
						</div>
						<Text weight="bold">
							<div className="d-flex align-items-baseline justify-content-center mt-3">
								{loading ? (
									<div
										className="d-flex justify-content-center"
										style={{ height: '56px' }}>
										<LoaderMini />
									</div>
								) : (
									<>
										<Symbol>R$</Symbol>
										<Price>
											{priceFormatter(valorAtual)}
										</Price>
									</>
								)}
							</div>
						</Text>
					</CardBody>
				</Card>
			</Col>
			<Col md="3" className="px-0">
				<CardBody className="h-100">
					<Text size="small" weight="bold" center>
						Ontem
					</Text>
					{loading ? (
						<div className="d-flex justify-content-center">
							<LoaderMini />
						</div>
					) : (
						<>
							<Text size="small" center color="gray">
								{`R$ ${priceFormatter(valorOntem)}`}
							</Text>
							<div className="mt-2">
								<Text
									size="medium"
									weight="bold"
									center
									color={
										valorAtual > valorOntem
											? 'green'
											: 'red'
									}>
									{porcentagem}
								</Text>
							</div>
						</>
					)}
				</CardBody>
			</Col>
		</div>
	);
}

export function CardSplit(props) {
	const { subtitulo, loading, dadosSplit } = props;

	return (
		<Card className="d-flex h-100" style={{ backgroundColor: color.blue }}>
			<CardBody
				style={{
					justifyContent: 'center',
					paddingLeft: 0,
					paddingRight: 0,
					width: '100%',
				}}>
				<div
					className="d-flex justify-content-center"
					style={{
						textAlign: 'center',
						marginTop: -5,
						marginBottom: 5,
					}}>
					<TextCardSplitDash
						size="medium"
						weight={subtitulo.weight}
						color="white">
						Plano Split
					</TextCardSplitDash>
				</div>
				<div className="d-flex justify-content-center">
					<TextCardSplitDash size="small" color="white">
						Recebe:
					</TextCardSplitDash>
				</div>
				{loading ? (
					<div className="d-flex justify-content-center">
						<LoaderMini />
					</div>
				) : (
					<>
						<div className="d-flex justify-content-center">
							<div className="d-flex justify-content-center align-items-center">
								<div
									style={{
										marginRight: '2px',
									}}>
									<TextCardSplitDash
										size="medium"
										weight={subtitulo.weight}
										color="white">
										{`${dadosSplit.porcentagem}%`}
									</TextCardSplitDash>
								</div>
								<div>
									<TextCardSplitDash
										size="small"
										color="white">
										na conta
									</TextCardSplitDash>
								</div>
							</div>
						</div>
						<div className="d-flex justify-content-center">
							<div className="d-flex justify-content-center align-items-center">
								<div
									style={{
										marginRight: '2px',
									}}>
									<TextCardSplitDash
										size="medium"
										weight={subtitulo.weight}
										color="white">
										{`${100 - dadosSplit.porcentagem}%`}
									</TextCardSplitDash>
								</div>
								<div>
									<TextCardSplitDash
										size="small"
										color="white">
										em crédito
									</TextCardSplitDash>
								</div>
							</div>
						</div>
					</>
				)}
			</CardBody>
		</Card>
	);
}

export function CardDash(props) {
	const {
		bgcolor,
		titulo,
		subtitulo,
		valorAtual,
		valorOntem,
		porcentagem,
		tag,
		loading,
		style,
	} = props;

	return (
		<Card bgcolor={bgcolor} style={style}>
			<CardBody>
				<div className="d-flex justify-content-between">
					<Text
						weight="bold"
						size="small"
						color={bgcolor === 'softBlack' ? 'white' : 'gray'}>
						{titulo.texto}
					</Text>
					<Text
						weight={subtitulo.weight}
						size="small"
						color={bgcolor === 'softBlack' ? 'white' : 'gray'}>
						{subtitulo.texto}
					</Text>
				</div>
				{loading ? (
					<div
						className="d-flex justify-content-center"
						style={{ height: tag ? '72px' : '54px' }}>
						<LoaderMini />
					</div>
				) : (
					<>
						<Text
							weight="bold"
							color={bgcolor === 'softBlack' ? 'white' : 'gray'}>
							<div className="d-flex align-items-baseline justify-content-center">
								<Symbol>R$</Symbol>
								<Price>{priceFormatter(valorAtual)}</Price>
							</div>
						</Text>
						{tag && (
							<div>
								<Text
									size="small"
									color={
										bgcolor === 'softBlack'
											? 'white'
											: 'gray'
									}>
									{`Ontem R$ ${priceFormatter(valorOntem)}`}
								</Text>
								<Tag
									textColor={
										valorAtual > valorOntem
											? 'green'
											: 'red'
									}>
									{porcentagem}
								</Tag>
							</div>
						)}
					</>
				)}
			</CardBody>
		</Card>
	);
}

export function CardDashError(props) {
	const { error } = props;
	return (
		<Card>
			<CardBody>
				Oops! Houve algum problema ao carregar as informações
				<Text weight="bold">{`Erro: ${error}`}</Text>
			</CardBody>
		</Card>
	);
}
